import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import { selectAnnouncementCompanyKey, selectSeenAnnouncements } from 'redux/selectors/general';
import { markAnnouncementSeen } from 'redux/slices/general';

import { ANNOUNCEMENTS } from './announcements';
import AnnouncementModal from './components/AnnouncementModal';

// Shows each company the newest feature announcement it hasn't seen yet, once.
// Add the next launch to ANNOUNCEMENTS; nothing here needs to change.
function FeatureAnnouncement({ isMobile }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const companyKey = useSelector(selectAnnouncementCompanyKey);
    const seenAnnouncements = useSelector(selectSeenAnnouncements);

    const announcement = ANNOUNCEMENTS.find(({ id }) => !seenAnnouncements.includes(id));

    if (!companyKey || !announcement) {
        return null;
    }

    const dismiss = () => dispatch(markAnnouncementSeen({ companyKey, id: announcement.id }));

    const handlePrimaryAction = () => {
        dismiss();
        history.push(announcement.primaryAction.to);
    };

    return (
        <AnnouncementModal
            open
            announcement={announcement}
            isMobile={isMobile}
            onClose={dismiss}
            onPrimaryAction={handlePrimaryAction}
        />
    );
}

FeatureAnnouncement.propTypes = {
    isMobile: PropTypes.bool,
};

export default FeatureAnnouncement;
